export default "$ yarn add @fortawesome/fontawesome-free -D\n// OR\n$ npm install @fortawesome/fontawesome-free -D\n";